import { cn } from "cn";
import { Skeleton } from "@/components/ui/skeleton";

export const FilterValueListSkeleton = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div className="p-1 flex flex-col gap-0.5">
      {Array.from({ length: 7 }).map((_, item) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length skeleton placeholder rows, no real data or reordering
        <Skeleton key={item} className={cn("h-8", className)} />
      ))}
    </div>
  );
};
